import auth from 'services/auth';
import tenant from './tenant';
import utils from './utils';
class User {
  private tokenKey = 'HRTPS_PRODUCTS_ADMIN_USER_TOKEN';
  private store: any = window.localStorage;
  private getTokenKey() {
    const tenantId = tenant.getTenantId();
    if (tenantId) return `${this.tokenKey}_${tenantId}`;
    return this.tokenKey;
  }
  getToken() {
    return this.store && this.store.getItem(this.getTokenKey());
  }
  setToken(token: string) {
    this.store && this.store.setItem(this.getTokenKey(), token);
  }
  removeToken() {
    this.store && this.store.removeItem(this.getTokenKey());
  }
  async logout() {
    const res = await auth.logout();
    if (res.success) {
      this.removeToken();
      utils.goLogin();
    }
  }
}
export default new User();
